export default __webpack_public_path__ + "static/media/staking_rewards.2709cb77.png";